// Please put date in YYYY-MM-DD format
export const wallpaperPhotos = [
    {
        name: "FLOW",
        desc: "Kool Wallpaper",
        date: "2020-07-04",
    	imgname: "flow.png",
    	credits: "Khandy",
    },
    {
        name: "FLOW",
        desc: "Kool Wallpaper",
        date: "2020-07-04",
    	imgname: "flow1.png",
    	credits: "Khandy",
    },
    {
        name: "FLOW",
        desc: "Kool Wallpaper",
        date: "2020-07-04",
    	imgname: "flow2.png",
    	credits: "Khandy",
    },
    {
        name: "StuyLumiere Season 1",
        desc: "The very first logo of StuyFlow's competitive flow team! Designed by Jasmine Xiao.",
        date: "2019-10-31",
    	imgname: "lumiere_season1.png",
    	credits: "Jasmine",
    },
    {
        name: "StuyFlow",
        desc: "StuyFlow's cover page. Designed by Jasmine Xiao.",
        date: "2019-10-31",
    	imgname: "logo_2019.png",
    	credits: "Jasmine",
    },
    {
        name: "StuyFlow",
        desc: "StuyFlow's profile picture. Designed by Jasmine Xiao.",
        date: "2019-10-31",
    	imgname: "logo_2020.png",
    	credits: "Jasmine",
    },
    {
        name: "Senior SING! 2020",
        desc: "Khandy's wonderful creation.",
        date: "2020-02-14",
    	imgname: "senior_sing_2020.png",
    	credits: "Khandy",
    },
    {
        name: "StuySquad 2020",
        desc: "We will never know who created this..... Aaron? Khandy? Chloe?",
        date: "2020-01-27",
    	imgname: "stuysquad_2020.png",
    	credits: "yeet",
    },
    {
        name: "Senior SING! 2020",
        desc: "Skyline and star themed, designed by Jasmine.",
        date: "2020-02-27",
    	imgname: "senior-sing-2020-0.png",
    	credits: "Jasmine",
    },
    {
        name: "Senior SING! 2020",
        desc: "Luna, designed by Jasmine.",
        date: "2020-02-27",
    	imgname: "senior-sing-2020-1.png",
    	credits: "Jasmine",
    },
]
